<template>
  <div class="site-nav">
    <div class="nav-bd-l">
      <ul>
        <li class="site-nav-menu">
          <a class="site-nav-link" @click="gotoIndex">
            <img :src="logo" class="site-nav-logo" />
          </a>
        </li>
      </ul>
    </div>
    <div class="nav-bd-r"></div>
    <div class="nav-bd-r" style="height: 1px">
      <!-- 伙伴中心站内信注释 -->
      <!-- <el-badge :is-dot="unReadMsgNumStatus" class="is-dot">
      <span class="iconfont icon-xinxi" @click="handleToStation"></span>
      </el-badge> -->
    </div>
    <div v-if="userName" class="nav-bd-r">
      <span
        @click="handleToCustomer"
        class="site-nav-username"
        v-popover:popoverAccount
        >{{ userName }}</span
      >
      <el-popover
        ref="popoverAccount"
        placement="bottom-start"
        trigger="hover"
        popper-class="myMenuPopover"
        visible-arrow
        v-model="visible"
        :open-delay="250"
        style="padding: 0px"
      >
        <ul>
          <li class="liUserMenu" v-if="$navBarItemPermission(`partnerCenter:partner`)" @click="baseInfoPath('partner')">
            <span class="menuLabel">伙伴控制台</span>
          </li>
          <li class="liUserMenu" v-if="$navBarItemPermission(`partnerCenter:password`)"  @click="modifyPsw('partner')">
            <span class="menuLabel">修改密码</span>
          </li>
          <li class="liUserMenuQuit" @click="logout()">
            <span class="menuLabel">退出登录</span>
          </li>
        </ul>
      </el-popover>
    </div>
    <div class="nav-bd-r nav-r user-photo" @click="handleToCustomer">
      <img src="../../img/user.png" alt class="userImg" />
    </div>
    <div class="nav-bd-r nav-r">
      <div class="worker-order top-nav-btn"  v-if="$navHasPermission('partner')" @click="linkTo('partner')">
        伙伴控制台
      </div>
      <div
        class="worker-order top-nav-btn"
        v-if="partnerType.includes('0') && $navHasPermission('reseller')"
        @click="linkTo('reseller')"
      >
        渠道中心
      </div>
      <!-- <div
        class="worker-order top-nav-btn"
        v-if="partnerType.includes('0')"
        @click="linkTo('finance')"
      >
        费用中心
      </div> -->
      <div class="worker-order top-nav-btn" v-if="$navHasPermission('finance')" @click="linkTo('finance')">
        <el-dropdown trigger="hover" v-if="partnerType.includes('0')">
          <span class="top-text">费用中心</span>
          <el-dropdown-menu
            slot="dropdown"
            class="personDown finance-drop-wrap"
          >
            <div
              class="finace-drop"
              v-for="(menu, index) in dropMenu"
              :key="index"
            >
              <div v-if="menu.isHead" class="drop-menu-head">
                {{ menu.label }}
              </div>
              <el-dropdown-item
                 v-else-if='$navBarItemPermission(`finance:${menu.name}`)'
                class="drop-menu-list"
                @click.native="dropMenuGo(menu.name)"
              >
                <span>{{ menu.label }}</span>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div
        class="worker-order top-nav-btn"
        v-if="partnerType.includes('1') && $navHasPermission('market')"
        @click="linkTo('market')"
      >
        云市场业务中心
      </div>
      <div class="worker-order top-nav-btn" v-if="$navHasPermission('workorder')" @click="linkTo('workorder')">
        <el-dropdown trigger="hover">
          <span class="top-text">工单</span>
          <el-dropdown-menu
            slot="dropdown"
            class="personDown finance-drop-wrap"
          >
            <div
              class="finace-drop"
              v-for="(menu, index) in workorderMenu"
              :key="index"
            >
              <div v-if="menu.isHead" class="drop-menu-head">
                {{ menu.label }}
              </div>
              <el-dropdown-item
                v-else-if='$navBarItemPermission(`workorder:${menu.name}`)'
                class="drop-menu-list"
                @click.native="dropMenuGo(menu.name)"
              >
                <span>{{ menu.label }}</span>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mainApi } from "@main/services";
import { accountApi } from "@user-center/account/services";
import { mapGetters, mapState } from "vuex";
import { utils } from "@/utils/utils";
import {
  workerOrderUrl,
  portalUrl,
  casLoginUrl,
  cooperativeUrl,
  financeWebUrl,
} from "@domain";
import { hostURL } from "@domain";
import { statisticsApi } from "@user-center/news/service";
export default {
  name: "TopBar",
  computed: {
    ...mapGetters(["userName", "userInfo", "planTypeList"]),
    systemTypes: function () {
      return this.$store.state.main.systemType;
    },
    ...mapState({
      isDot: (state) => state.news.isDot,
    }),
    isActive() {
      return this.$route.path.indexOf("/main") != -1;
    },
    // showBaseInfo(){
    //   let localStorageLeftMenuData = JSON.parse(
    //     localStorage.getItem("leftMenuData")
    //   );
    //   let returnFlag = false;
    //   let pathName = "/user-center/account/base-info";
    //   if(Array.isArray(localStorageLeftMenuData)){
    //     localStorageLeftMenuData.forEach((item,index) => {
    //       if(pathName.indexOf(item.name)>=0){
    //         if(Array.isArray(item.children)){
    //           item.children.forEach((element,index2)=>{
    //             if(pathName.indexOf(`${item.name}/${element.name}`)>=0){
    //               returnFlag = true;
    //             }
    //           })
    //         }
    //       }
    //     });
    //   }
    //   return returnFlag;
    // }
  },
  data() {
    return {
      visible: false,
      logo: `${casLoginUrl}/cas/custom/img/logo-white.png`,
      partnerType: [],
      clientTypeMap: {
        partner: "2",
      },
      unReadMsgNum: 0,
      unReadMsgNumStatus: false,
      dropMenu: [
        { label: "账户管理", isHead: true },
        { label: "充值", name: "reCharge" },
        { label: "拨款到云厂商", name: "Grant" },
        { label: "合同与发票", isHead: true },
        { label: "发票管理", name: "Invoice" },
        { label: "合同管理", name: "Contract" },
      ],
      workorderMenu: [
        { label: "工单管理", isHead: true },
        { label: "新建工单", name: "Add" },
        { label: "我的工单", name: "MyInfo" },
      ],
    };
  },
  mounted() {
    // 初次从状态管理里获取来判断是否显示渠道中心
    this.getPartnerType(this.planTypeList);
    this.websocketInit();
    this.queryMsgNumByModule();
    // 再次通过全局捕获事件处理，来判断是否显示渠道中心
    window.addEventListener("click", this.isJoinPlan);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.isJoinPlan);
  },
  methods: {
    dropMenuGo(key) {
      switch (key) {
        case "reCharge":
          window.open(`${financeWebUrl}/reseller/user-center/debits/recharge`);
          break;
        case "Grant":
          window.open(`${financeWebUrl}/reseller/user-center/debits/grant`);
          break;
        case "Invoice":
          window.open(`${financeWebUrl}/reseller/user-center/defend/invoice`);
          break;
        case "Contract":
          window.open(`${financeWebUrl}/reseller/user-center/defend/contract`);
          break;
        case "Add":
          window.open(`${workerOrderUrl}/order/manager/create`);
          break;
        case "MyInfo":
          window.open(`${workerOrderUrl}/order/manager/mine`);
          break;
      }
    },
    handleToCustomer() {
      this.$router.push("/user-center/account/base-info");
    },
    // 获取用户信息
    isJoinPlan() {
      mainApi.queryPartenrStatus().then((res) => {
        if (res.result) {
          if (res.obj) {
            if (res.obj.typeList) {
              // 将是否加入渠道计划添加到全局中
              this.$store.commit("setIsJoinPlan", res.obj.typeList);
              this.$nextTick(() => {
                this.getPartnerType(res.obj.typeList);
              });
            }
          }
        }
      });
    },
    // 站内信条数
    async queryMsgNumByModule() {
      const data = {
        oneMsgType: "200", // oneMsgType：  customer 客户端 100    channel 渠道端 200   operation 运营端 300
      };
      const { result, obj } = await statisticsApi.queryMsgNumByModule(data);
      if (result) {
        this.unReadMsgNum = obj.unreadMsgNum;
        if (obj.unreadMsgNum == 0) {
          this.unReadMsgNumStatus = false;
        } else {
          this.unReadMsgNumStatus = true;
        }
        this.$store.commit("news/timelyMsg", obj.unReadMsgNumStatus);
      }
    },
    websocketInit() {
      this.$websocket.websocketReconnect(this.userInfo.userCode, (data) => {
        const { msgType } = JSON.parse(data.body);
        if (msgType.length === 6) {
          setTimeout(() => {
            this.queryMsgNumByModule();
          }, 500);
        }
      });
    },
    handleToStation() {
      this.$router.push("/user-center/news/station");
    },
    login() {
      utils.setLogin();
    },
    logout() {
      utils.setLogout();
      this.visible = !this.visible;
    },
    gotoIndex() {
      window.open(`${portalUrl}`);
    },
    baseInfoPath(type) {
      // localStorage.setItem("defaultActive", "1-0");
      this.$router.push("/user-center/account/base-info");
      this.visible = !this.visible;
    },
    modifyPsw(type) {
      // localStorage.setItem("defaultActive", "");
      this.$router.push({ path: "/main/account" });
      this.visible = !this.visible;
    },
    // 充值
    goCharge() {
      this.$router.push({
        path: "/user-center/debits/recharge",
      });
    },
    linkTo(n) {
      switch (n) {
        case "finance":
          // 跳转到费用中心
          accountApi.clientQueryBaseInfo().then((res) => {
            // authStatus 认证状态：0已认证 1未认证 2待审核 3认证失败（已驳回） 4认证中
            if (res.result && res.obj) {
              if (res.obj.authStatus === "0") {
                window.open(`${financeWebUrl}`);
              } else {
                this.$confirm("您还未实名认证，请先完成实名认证", "提示", {
                  confirmButtonText: "实名认证",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(async () => {
                    this.$router.push("/user-center/account/certification");
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              }
            }
          });
          // window.open(`${financeWebUrl}`);
          break;
        case "partner":
          // 跳转到伙伴控制台
          this.$router.push({
            path: "/",
          });
          break;
        case "reseller":
          // 跳转到渠道中心
          accountApi.clientQueryBaseInfo().then((res) => {
            // authStatus 认证状态：0已认证 1未认证 2待审核 3认证失败（已驳回） 4认证中
            if (res.result && res.obj) {
              if (res.obj.authStatus === "0") {
                window.open(hostURL);
              } else {
                this.$confirm("您还未实名认证，请先完成实名认证", "提示", {
                  confirmButtonText: "实名认证",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(async () => {
                    this.$router.push("/user-center/account/certification");
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              }
            }
          });
          break;
        case "market":
          // 跳转到云市场业务中心
          window.open(`${cooperativeUrl}/provider`);
          break;
        case "workorder":
          // 跳转到工单管理
          window.open(`${workerOrderUrl}/order/manager/mine`);
          break;
      }
    },
    // 查询伙伴类型
    getPartnerType(list) {
      let typeList = list || {};
      this.partnerType = [];
      if (typeList instanceof Array) {
        typeList.forEach((item) => {
          if (item.joinPlanFlag) {
            this.partnerType.push(item.partnerType);
          }
        });
      }
    },
  },
  watch: {
    // systemTypes(newVal, oldVal) {
    //   this.getMenuData(newVal);
    // },
    isDot(newVal, oldVal) {
      console.log("newVal", newVal);
      // this.unReadMsgNum = newVal;
      this.unReadMsgNumStatus = newVal;
    },
  },
};
</script>
<style lang="scss" src="@main/css/top-bar.scss"></style>
<style lang="scss" scoped>
.liUserMenu,
.liUserMenuQuit {
  color: #212a40;
  font-size: 14px;
  line-height: 30px;
  text-align: left;
  cursor: pointer;
  padding-left: 10px;
  border-left: 2px solid transparent;
}
.liUserMenu:hover {
  background: #ecf3ff;
  border-left: 2px solid #3369ff;
}
.liUserMenuQuit:last-child {
  border-top: 1px solid #dbdeea;
  line-height: 34px;
  color: #a3a9b7;
  margin-top: 8px;
}
.site-nav {
  .user-photo {
    margin-right: 0px;
    padding-top: 11px;
    cursor: pointer;
    .userImg {
      width: 28px;
      height: 28px;
    }
  }
  .site-nav-subname {
    color: #fff;
    text-align: center;
  }
  .top-nav-btn {
    color: #fff;
    opacity: 0.7;
    cursor: pointer;
    &:hover {
      opacity: 1;
    }
  }
  .menu-center-navbar {
    color: #fff;
    cursor: pointer;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: #fff;
      opacity: 0.7;
    }
  }
  .top-nav-btn.active {
    opacity: 1;
  }
  .nav-r {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    .worker-order {
      margin-right: 20px;
    }
  }
}
.icon-xinxi {
  color: #fff;
  cursor: pointer;
}
/deep/ .is-dot {
  .el-badge__content.is-fixed {
    top: 19px !important;
  }
}

/deep/ .el-badge__content.is-dot {
  height: 6px;
  width: 6px;
}
.personDown {
  width: 184px;
}
.finance-drop-wrap {
  width: 120px !important;
  position: relative;
  top: 48px !important;
  left: 0;
}
.drop-menu-head {
  color: #a3a9b7;
  padding-left: 12px;
  font-size: 12px;
  line-height: 24px;
  border-top: 1px solid #dbdeea;
  margin-top: 8px;
  padding-top: 8px;
}
.drop-menu-list {
  color: #212a40;
  line-height: 30px;
}
.finace-drop:nth-of-type(1) {
  .drop-menu-head {
    border-top: 0;
    margin-top: 0px;
    padding-top: 8px;
  }
}
.top-text {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/modules/main/view/layout/TopBar.vue